export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/brand-dc.cf519c65.svg","height":16,"width":26,"blurWidth":0,"blurHeight":0};